import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselTotalPriceDialogComponent } from './vessel-total-price-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@NgModule({
  declarations: [VesselTotalPriceDialogComponent],
  imports: [CommonModule, MatRadioModule, MatIconModule],
  exports: [VesselTotalPriceDialogComponent],
  providers: [{ provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }],
})
export class VesselTotalPriceDialogModule {}
